export default "__VITE_ASSET__3$_Sxiua__"